module.exports = __webpack_public_path__ + "static/media/trashRed.85e1390c.svg";